import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from '@/App';
import { ToastProvider } from '@/components/ui';
// i18n: importing boots i18next; apply <html dir>/<html lang> synchronously from
// the saved language before React mounts so Hebrew paints RTL with no flash.
import i18n, { applyDirAndLang, LANGUAGE_LOCALSTORAGE_KEY } from '@/i18n';
import '@/styles/index.css';

applyDirAndLang(localStorage.getItem(LANGUAGE_LOCALSTORAGE_KEY) || i18n.language || 'en');

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <App />
      </ToastProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
